import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getRecompensas, resgatar, getExtrato } from '../services/api';

export default function Fidelidade() {
  const { user, updatePontos } = useAuth();
  const [recompensas, setRecompensas] = useState([]);
  const [extrato, setExtrato] = useState([]);
  const [aba, setAba] = useState('resgatar');
  const [toast, setToast] = useState('');

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 3000); };
  const pts = user?.pontos || 0;

  useEffect(() => {
    getRecompensas().then(r => setRecompensas(r.data)).catch(() => {});
    getExtrato().then(r => setExtrato(r.data)).catch(() => {});
  }, []);

  const handleResgatar = async (r) => {
    if (pts < r.custo_pontos) return showToast('⚠️ Pontos insuficientes!');
    try {
      const res = await resgatar(r.id);
      showToast('🎉 ' + res.data.mensagem);
      updatePontos(res.data.pontos_restantes);
    } catch (e) { showToast('❌ ' + (e.response?.data?.error || 'Erro')); }
  };

  const pct = Math.min((pts % 500) / 500 * 100, 100);

  return (
    <div style={{ padding: 16 }}>
      {toast && <div style={{ position: 'fixed', top: 60, left: '50%', transform: 'translateX(-50%)', background: 'linear-gradient(90deg,var(--red),var(--orange))', color: '#fff', padding: '10px 20px', borderRadius: 20, fontSize: 13, fontWeight: 700, zIndex: 999, whiteSpace: 'nowrap' }}>{toast}</div>}

      <h2>⭐ Programa Fidelidade</h2>

      {/* Card de pontos */}
      <div style={{ background: 'linear-gradient(135deg,#1a0000,#0a1a0a)', border: '1px solid var(--orange)', borderRadius: 12, padding: 20, marginBottom: 16, position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', right: -10, bottom: -10, fontSize: 80, opacity: .05 }}>⭐</div>
        <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 4 }}>SEUS PONTOS</div>
        <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 64, color: 'var(--orange)', lineHeight: 1 }}>{pts}</div>
        <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 4 }}>A cada R$1,00 gasto = 1 ponto</div>
        <div style={{ background: 'var(--bg4)', borderRadius: 4, height: 8, margin: '14px 0 6px', overflow: 'hidden' }}>
          <div style={{ height: '100%', width: `${pct}%`, background: 'linear-gradient(90deg,var(--red),var(--orange))', borderRadius: 4, transition: 'width .5s' }} />
        </div>
        <div style={{ fontSize: 11, color: 'var(--text2)' }}>{500 - (pts % 500)} pontos para o próximo nível</div>
      </div>

      {/* Abas */}
      <div style={{ display: 'flex', gap: 4, background: 'var(--bg3)', padding: 4, borderRadius: 8, marginBottom: 14 }}>
        {[['resgatar', '🎁 Resgatar'], ['extrato', '📋 Extrato']].map(([key, label]) => (
          <button key={key} onClick={() => setAba(key)} style={{
            flex: 1, background: aba === key ? 'linear-gradient(90deg,var(--red),var(--orange))' : 'none',
            border: 'none', color: aba === key ? '#fff' : 'var(--text2)',
            padding: 8, borderRadius: 6, cursor: 'pointer', fontFamily: 'Nunito,sans-serif', fontWeight: 700, fontSize: 12
          }}>{label}</button>
        ))}
      </div>

      {aba === 'resgatar' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          {recompensas.map(r => {
            const desbloqueado = pts >= r.custo_pontos;
            return (
              <div key={r.id} onClick={() => handleResgatar(r)} style={{
                background: 'var(--bg3)', border: `1px solid ${desbloqueado ? 'var(--orange)' : 'var(--border)'}`,
                borderRadius: 10, padding: 14, textAlign: 'center', cursor: desbloqueado ? 'pointer' : 'not-allowed',
                opacity: desbloqueado ? 1 : 0.5, transition: 'all .2s'
              }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>🎁</div>
                <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 4 }}>{r.nome}</div>
                <div style={{ fontSize: 13, fontWeight: 800, color: desbloqueado ? '#2ea82e' : 'var(--orange)' }}>
                  {desbloqueado ? '✅ Disponível' : `${r.custo_pontos} pts`}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {aba === 'extrato' && (
        <div>
          {!extrato.length ? <div className="empty-state"><div className="icon">📋</div><p>Nenhuma transação ainda</p></div> : extrato.map(t => (
            <div key={t.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{t.descricao}</div>
                <div style={{ fontSize: 11, color: 'var(--text3)' }}>{new Date(t.criado_em).toLocaleDateString('pt-BR')}</div>
              </div>
              <span style={{ fontWeight: 800, color: t.quantidade > 0 ? '#2ea82e' : 'var(--red)', fontSize: 14 }}>
                {t.quantidade > 0 ? '+' : ''}{t.quantidade} pts
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
